import { useEffect, useRef } from 'react'
import { SDrawerOrModal, SLowcodeList } from 'shj-components'
import { config } from './config'
import { getConstructionCostList } from '@/services/product'
import { isArray, uniqueId } from 'lodash-es'
import { Col, Divider, Row, Space, Tooltip } from 'antd'
import styles from './index.module.less'
export default function ConstructionCostModal(props: any) {
  const { open, onClose, loading, record } = props
  const listRef = useRef<any>(null)
  const showTypeInfo = {
    PROCESS_LABOR: {
      titleName: '人工',
      secondeTitleShowName: '技能标签',
      secondeTitleKey: 'workTypeName',
      finallyTitleShowName: '人工定额（元）',
    },
    PROCESS_AUXILIARY_MATERIAL: {
      titleName: '辅材',
      secondeTitleShowName: '定额名称',
      secondeTitleKey: 'quotaMaterialName',
      thirdTitleShowName: '定额方式',
      thirdTitleKey: 'quotaTypeName',
      fourthTiltleShowName: '物料渠道价（元）',
      fifthTitleShowName: '定额（含耗损）',
      fifthTitleKey: 'totalNum',
      finallyTitleShowName: '辅材定额（元）',
    },
    PROCESS_OUTER: {
      titleName: '外包',
      secondeTitleShowName: '外包商',
      secondeTitleKey: 'vendorName',
      thirdTitleShowName: '服务单价（元）',
      thirdTitleKey: 'channelPrice',
      fifthTitleShowName: '定额',
      fifthTitleKey: 'quotaNum',
      finallyTitleShowName: '外包定额（元）',
    },
  }
  useEffect(() => {
    getConstructionCostList({
      data: {
        productId: record?.productId,
        skuId: record?.skuId,
        effectiveDate: record?.effectiveDate,
        companyId: record?.companyId,
      },
    }).then((res: any) => {
      if (isArray(res) && res.length) {
        res = res.map((item: any) => {
          item.id = uniqueId()
          item.price = item.dtlVoList?.reduce((pre: any, cur: any) => {
            return pre + cur?.price
          }, 0)
          return item
        })
      }
      listRef.current?.updateDataSource(res, res?.length)
    })
  }, [record])
  const expandedRowRender = (record: any) => {
    if (record?.dtlVoList?.length) {
      return (
        <Space direction='vertical'  style={{ display: 'flex' }} split={<Divider type="horizontal" />} size={[8, 0]}>
          {record?.dtlVoList.map((item: any) => {
            return (
              <Row gutter={[16, 16]} className={styles.constructionCostRow}>
                <Col span={1} style={{ fontSize: 12 }}>
                  {showTypeInfo[item?.costType]?.titleName}
                </Col>
                <Col style={{ fontSize: 12 }} span={6}>
                  <div
                    style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}
                  >
                    {showTypeInfo[item?.costType]?.secondeTitleShowName}：
                    <Tooltip
                      placement="topLeft"
                      title={`${item?.quotaInfo[showTypeInfo[item?.costType]?.secondeTitleKey]}`}
                    >
                      {item?.quotaInfo[showTypeInfo[item?.costType]?.secondeTitleKey]}
                    </Tooltip>
                  </div>
                </Col>
                <Col style={{ fontSize: 12 }} span={4}>
                  {showTypeInfo[item?.costType]?.thirdTitleShowName
                    ? `${showTypeInfo[item?.costType]?.thirdTitleShowName}：${item?.costType === 'PROCESS_AUXILIARY_MATERIAL' ? item?.quotaInfo[showTypeInfo[item?.costType]?.thirdTitleKey] : item?.channelPrice}`
                    : null}
                </Col>
                <Col style={{ fontSize: 12 }} span={4}>
                  {showTypeInfo[item?.costType]?.fourthTiltleShowName &&
                  item?.quotaInfo?.quotaType !== 'PROCESS_PRICE'
                    ? `${showTypeInfo[item?.costType]?.fourthTiltleShowName}：${item?.channelPrice}`
                    : null}
                </Col>
                <Col style={{ fontSize: 12 }} span={5}>
                  {showTypeInfo[item?.costType]?.fifthTitleShowName
                    ? `${showTypeInfo[item?.costType]?.fifthTitleShowName}：${item?.quotaInfo[showTypeInfo[item?.costType]?.fifthTitleKey]}`
                    : null}
                </Col>
                <Col style={{ fontSize: 12 }} span={4}>
                  {showTypeInfo[item?.costType]?.finallyTitleShowName}：{item?.price}
                </Col>
              </Row>
            )
          })}
        </Space>
      )
    }
  }
  return (
    <SDrawerOrModal
      mode="modal"
      open={open}
      onCancel={() => onClose()}
      antdProps={{
        footer: null,
      }}
      loading={loading}
      width={1200}
      title={'施工项成本构成'}
    >
      <div className={styles.constructionModal}>
        <div style={{ color: 'red', textAlign: 'right', marginBottom: 10 }}>
          产品采购价（成本价/渠道价）： {record.purchasePrice || '-'}元
        </div>
        <SLowcodeList
          ref={listRef}
          searchMode="group"
          config={config}
          rowKey="id"
          expandable={{
            expandedRowRender: record => expandedRowRender(record),
            // rowExpandable: record => record.name !== 'Not Expandable',
          }}
        />
      </div>
    </SDrawerOrModal>
  )
}
